import * as React from 'react';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

const dropdownVariants = ['default', 'profile', 'submenus'] as const;
type DropdownVariant = (typeof dropdownVariants)[number];

export function DropdownShowcase() {
  const [variant, setVariant] = React.useState<DropdownVariant>('default');

  return (
    <div className="space-y-4">
      <StateToggle
        options={dropdownVariants}
        value={variant}
        onChange={setVariant}
        label="Variant"
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="md" variant="outline">
            Open menu
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          {variant === 'profile' ? (
            <>
              <DropdownMenuItem
                onSelect={(e) => e.preventDefault()}
                className="gap-3 focus:bg-transparent"
              >
                <Avatar className="h-8 w-8">
                  <AvatarImage src="https://i.pravatar.cc/32" alt="Paul B" />
                  <AvatarFallback>PB</AvatarFallback>
                </Avatar>
                <div className="flex flex-col">
                  <span className="text-sm font-medium">Paul B</span>
                  <span className="text-xs text-muted-foreground truncate max-w-[140px]">
                    paul@example.com
                  </span>
                </div>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          ) : null}

          <DropdownMenuItem>Settings</DropdownMenuItem>
          <DropdownMenuItem>Dark mode</DropdownMenuItem>

          {variant === 'submenus' ? (
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>Language</DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                <DropdownMenuItem>English</DropdownMenuItem>
                <DropdownMenuItem>Spanish</DropdownMenuItem>
                <DropdownMenuItem>French</DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ) : null}

          <DropdownMenuSeparator />
          <DropdownMenuItem>Sign out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
